import React from "react";
import HomescreenWidgetForm from "./HomescreenWidgetForm";

const AddHomescreenWidget = (props) => <HomescreenWidgetForm props={props} edit={false} />;

export default AddHomescreenWidget;
